// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"styles_bannerWrapper__29tMP","banner":"styles_banner__3oiOi"};